import { Capability } from "../../../../api/types";
import React from "react";
import { Text } from "@react-pdf/renderer";
import { currResultsStyle } from "./CurriculumResultsContent";

export interface AggregatedCapabilityProps {
	capabilities: Array<Capability>;
}

// aggregate capabilities and display aggregated text for one curriculum
export const AggregatedCapability: React.FC<AggregatedCapabilityProps> = ({
	capabilities,
}): JSX.Element => {
	let aggregatedCapability = "";
	if (capabilities) {
		capabilities.forEach((cap) => {
			aggregatedCapability =
				aggregatedCapability === ""
					? cap.name
					: aggregatedCapability + "; " + cap.name;
		});
	}
	return (
		<Text style={currResultsStyle.curriculumEntryContent}>
			{aggregatedCapability}
		</Text>
	);
};
